import React from "react";
import { AiOutlineMail } from "react-icons/ai";
import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";
import Paragraph from "../../shared/paragraphs";
import { Container } from "./styles";
import relatorio from "../../assets/pdf/relatorio_anual_2021.pdf";

function Footer() {
  return (
    <Container>
      <div>
        <Paragraph text={"Circuito Inclusão"} color={"white"} type={"P2"} />

        <a
          href="https://www.google.com/maps/place/Circuito+Inclus%C3%A3o/@-19.8544475,-44.0400663,17z/data=!3m1!4b1!4m5!3m4!1s0xa693fa33782edd:0x976d219036e09cd1!8m2!3d-19.8544526!4d-44.0378776"
          className="endereco"
        >
          Rua Paulo César de Mendonça, 160 Bairro Pedra Azul - Contagem/MG
        </a>

        <Paragraph text={"Contato"} color={"white"} type={"P2"} />
        <a href="mailto:http://circuitoinclusão@gmail.com">
          <AiOutlineMail size={"24"} />
          <span>{"http://circuitoinclusão@gmail.com"}</span>
        </a>
        <a href="https://wa.me/005531985681797" className="whatsapp">
          <FaWhatsapp size={"24"} />
          <span>(31) 98568-1797</span>
        </a>
      </div>
      <div>
        <Paragraph
          text={
            "Acompanhe as nossas redes sociais e fique por dentro das nossas ações!"
          }
          color={"white"}
          type={"P2"}
        />
        <ul>
          <li>
            <a href=" https://www.instagram.com/circuitoinclusao/">
              <FaInstagram />
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/circuitoinclusao">
              <FaFacebookSquare />
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/circuito-inclus%C3%A3o/">
              <FaLinkedin />
            </a>
          </li>
        </ul>
        <Paragraph text={"Transparência:"} color={"white"} type={"P2"} />
        <a download={relatorio} href={`download:${relatorio}`}>
          {" "}
          Relatorório Anual 2021{" "}
        </a>
      </div>
    </Container>
  );
}

export default Footer;
